class InteractiveImage {
  constructor(data) {
    this.text = data.text
    this.position = data.position
    this.imageUrl = data.imageUrl
    this.hoverImageUrl = data.hoverImageUrl
  }

  get type() {
    return 'image'
  }

  getHtmlOutput() {
    var image = '';
    if (this.hoverImageUrl) {
      image += '<img class="hovered" src="' + this.hoverImageUrl + '">'
    }
    if (this.imageUrl) {
      image += '<img class="non-hovered" src="' + this.imageUrl + '">'
    }
    if (!image) {
      image = '<div style="width:100%; height: 100%" ></div>'
    }
    var label = ''
    if (this.text) {
      label = '<div class="interactive-label ' + this.position + '"><span>' + this.text + '</span></div>'
    }
    if (this.position === 'bottom') {
      return image + label;
    }
    return label + image;
  }
}

export { InteractiveImage }
